<template>
    <div class="multi-step-">
        <design-2021-apprentice-multistep-form-wizard-form-header-component :title="$t('multistep.project_title')">
        </design-2021-apprentice-multistep-form-wizard-form-header-component>

        <b-alert
            class="projecttype-name-error"
            v-if="hasError"
            show
            variant="danger">
            {{ $t('multistep.project_title_cannot_be_empty') }}
        </b-alert>

        <b-form-group
            class="projecttype-name-group"
            :label="$t('multistep.project_title')"
            label-for="projecttype-name-input">
            <template v-slot:label> {{ $t('multistep.project_title') }}: <span class="required">*</span> </template>
            <b-form-input
                id="projecttype-name-input"
                v-model="text"
                :placeholder="$t('multistep.project_title')"
                @input="handleInput"
                @keyup.enter="onEnter">
            </b-form-input>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: 'design-2021-apprentice-multistep-wizard-project-name-step-component',
    props: ['value'],
    data() {
        return {
            text: this.value,
            hasError: false,
        };
    },

    methods: {
        handleInput() {
            this.$emit('input', this.text);
        },
        updateText(text) {
            this.text = text;
        },
        async checkForErrors() {
            this.hasError = false;

            if (this.text === '') {
                this.hasError = true;
                const response = true;
                return await response;
            }
        },

        onEnter() {
            this.$emit('handleEnter');
        },
    },
};
</script>

<style scoped lang="scss">
@media (min-width: map-get($grid-breakpoints, 'md')) {
    input {
        max-width: 300px;
    }
}
</style>
